import axios from './api';

export default {
  getNames(){
    return axios.get('/api/providers/names').then(res => res.data);
  },
  getAllProviders() {
    return axios.get('/api/provider').then(res => res.data);
  },
  getProviders(page, q, f) {
    if (q) {
      if (f) {
        return axios.get(`/api/provider?page=${page}&q=${q}&f=${f}`).then(res => res.data)
      } else {
        return axios.get(`/api/provider?page=${page}&q=${q}`).then(res => res.data)
      }
    } else if (f){
      return axios.get(`/api/provider?page=${page}&f=${f}`).then(res => res.data)
    } else {
      return axios.get(`/api/provider?page=${page}`).then(res => res.data)
    }
  },
  getProvidersById(id) {
    return axios.get(`/api/provider/${id}`).then(res => res.data);
  },
  createProvider(provider) {
    return axios.post('/api/provider', provider).then(res => res.data);
  },
  removeProvider(id) {
    return axios.delete(`/api/provider/${id}`).then(res => res.data);
  },
  updateProvider(id, provider) {
    return axios.put(`/api/provider/${id}`, provider).then(res => res.data);
  },
}